import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTableModule } from '@angular/cdk/table';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatStepperModule,
  MatPaginatorIntl,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  DateAdapter,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatFormFieldModule,
} from '@angular/material';

import { LayoutRoutingModule } from './layout-routing.module';
import { LastDirective } from '../directive/LastDirective.directive';
import { modalComponent } from '../utils/modal/modal.component';
import { DataService } from '../utils/data.service';
import { getESPaginatorIntl } from '../es-paginator-intl';
import { MomentDateAdapter, MOMENT_DATE_FORMATS } from '../moment-date-adapter';

// Pages

//Inicio
import { InicioComponent } from '../inicio/inicio.component';
import { DiskSpaceComponent } from '../inicio/disk-space/disk-space.component';
import { AnalyticsComponent } from '../inicio/analytics/analytics.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

// Personal
import { PersonalComponent } from '../personal/personal.component';
import { PersonalConsultarComponent } from '../personal/consultar-eliminar/personal-consultar.component';
import { PersonalDetalleComponent } from '../personal/agregar-editar/personal-detalle.component';
import { PersonalEliminarComponent } from '../personal/consultar-eliminar/personal-eliminar.component';

// Familiar
import { FamiliarComponent } from '../familiar/familiar.component';
import { FamiliarAddEditComponent } from '../familiar/agregar-editar/familiarAddEdit.component';
import { CotizacionComponent } from '../cliente/cotizacion/consultar-eliminar/cotizacion.component';
import { CotizacionAddEditComponent } from '../cliente/cotizacion/agregar-editar/cotizacionAddEdit.component';

// Cliente
import { ClienteComponent } from '../cliente/cliente.component';
import { ClienteConsultarComponent } from '../cliente/consultar-eliminar/cliente-consultar.component';
import { ClienteDetalleComponent } from '../cliente/agregar-editar/cliente-detalle.component';
import { HistorialPagosComponent } from '../cliente-sae/historial-pagos/historial-pagos.component';
//Cliente SAE
import {modalChangeToCashOutComponent} from '../cliente-sae/historial-pagos/cahngeToCashOut/changeToCashOut.component';
//Cuentas por cobrar
import { cuentasCobrarComponent } from '../cuentasCobrar/cuentasCobrar.component';
import { cuentasCobrarFacturaComponent } from '../cuentasCobrarFactura/cuentasCobrarFactura.component';
// Bitacora
import { BitacoraComponent } from '../personal/bitacora/bitacora.component';
import { BitacoraAddEditComponent } from '../personal/bitacora/agregar-editar/bitacora-addedit.component';

// Bitacora Cliente
import { BitacoraClienteComponent } from '../cliente/bitacora/bitacoraCliente.component';
import { BitacoraClienteAddEditComponent } from '../cliente/bitacora/agregar-editar/bitacoraCliente-addedit.component';

// asistencia
import { controlAsistenciaNominaComponent } from '../asistenciaNomina/controlAsistenciaNomina.component';

// usuario
import { usuarioComponent } from '../usuario/usuario.component';
import { usuarioAddEditComponent } from '../usuario/agregar-editar/usuarioAddEdit.component';
import { usuarioConsultarComponent } from '../usuario/consultar-eliminar/usuarioConsultar.component';

// Ubicacion
import { UbicacionComponent } from '../cliente/ubicacion/ubicacion.component';
import { UbicacionAddEditComponent } from '../cliente/ubicacion/agregar-editar/ubicacion-addedit.component';

// nomina
import { nominaComponent } from '../nomina/nomina.component';
import { generarNominaComponent } from '../nomina/generarNomina/generar-nomina.component';

// personalCliente
import { PersonalClienteComponent } from '../cliente/personalCliente/personalCliente.component';

// personal documento
import { documentoComponent } from '../personal/documentos/documento.component';
import { documentoAddEditComponent } from '../personal/documentos/agregar-editar/documentoAddEdit.component';

// compania
import { CompaniaComponent } from '../compania/compania.component';
import { CompaniaConsultarComponent } from '../compania/consultar-eliminar/compania-consultar.component';
import { CompaniaDetalleComponent } from '../compania/agregar-editar/compania-detalle.component';
import { CompaniaConfiguracionComponent } from '../compania/configuracion/compania-configuracion.component';

// Producto
import { ProductComponent } from '../product/product.component';
import { ProductConsultDeleteComponent } from '../product/consult-delete/product-consult-delete.component';
import { ProductAddEditComponent } from '../product/add-edit/product-add-edit.component';
import { SaleExportComponent } from '../venta/sale-export/sale-export.component';
import { EditCodeSatComponent } from '../product/edit-code-sat/edit-code-sat.component';
import { EditUnitSatComponent } from '../product/edit-unit-sat/edit-unit-sat.component';

// venta
import { VentaAgregarComponent } from '../venta/agregar/venta-agregar.component';
import { VentaConsultarComponent } from '../venta/consultar/venta-consultar.component';

// pago venta
import { PagoVentaService } from '../pago-venta/pago-venta.service';

// Descuentos
import { DescuentosConsultarComponent } from '../descuentos/consultar/descuentos-consultar.component';
import { RetirosComponent } from '../retiros/retiros.component';

// Lista Precios
import { ListaPreciosComponent } from '../lista-precios/lista-precios/lista-precios.component';
import { ListaPreciosAgregarEditarComponent } from '../lista-precios/lista-precios-agregar-editar/lista-precios-agregar-editar.component';

// Materiales
import { MaterialesComponent} from '../materiales/materiales.component';
import { MaterialesConsultDeleteComponent } from '../materiales/consult-delete/materiales-consult-delete.component';
import { MaterialesAddEditComponent } from '../materiales/add-edit/materiales-add-edit.component';

// Item SubFamily
import {ItemSubFamiliaComponent} from '../subfamilia/item-subfamily.component';
import { ItemSubFamiliaConsultDeleteComponent } from '../subfamilia/consult-delete/item-subfamily-consult-delete.component';
import { ItemSubFamiliaAddEditComponent } from '../subfamilia/add-edit/item-subfamily-add-edit.component';

// Item Family
import {ItemFamiliaComponent} from '../familia/item-family.component';
import { ItemFamiliaConsultDeleteComponent } from '../familia/consult-delete/item-family-consult-delete.component';
import { ItemFamiliaAddEditComponent } from '../familia/add-edit/item-family-add-edit.component';

//Item Sat
import {ItemSatConsultarComponent} from '../itemSat/consultar/itemSat-consultar.component'
import {ItemSatAddEditComponent}  from '../itemSat/agregar-editar/itemSat-agregar-editar'

// Modal Confirmación
import { modalConfirmationComponent } from '../utils/modal/modal-confirmation.component';
import { ClienteSaeComponent } from '../cliente-sae/cliente-sae.component';
import { ClienteSaeAgregarEditarComponent } from '../cliente-sae/cliente-sae-agregar-editar/cliente-sae-agregar-editar.component';
import { PagoVentaComponent } from '../pago-venta/pago-venta.component';
import { OnlyNumberDirective } from '../utils/directives/only-number.directive';
import { FacturaComponent } from '../factura/factura.component';
import { FacturaConsultarComponent } from '../factura/consultar-eliminar/factura-consultar.component';
import { FacturaEliminarComponent } from '../factura/consultar-eliminar/factura-eliminar.component';
import { FacturaDetalleComponent } from '../factura/agregar-editar/factura-detalle.component';
import {modalImpuestosRetendidos} from '../factura/agregar-editar/impuestosRetenidos/impuestosRetenidos.component'
//Carta Porte
import {modalFechaPagoFactura} from '../factura/consultar-eliminar/fechaPago/fecha-pago.component';
import {CartaPorte} from '../factura/cartaPorte/carta-porte.component';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgSelectModule } from '@ng-select/ng-select';
import { from } from 'core-js/fn/array';
import { RealizarCorteCajaComponent } from '../corte-caja/realizar-corte-caja/realizar-corte-caja.component';
import { HistoricoCorteCajaComponent } from '../corte-caja/historico-corte-caja/historico-corte-caja.component';
import { CorteCajaComponent } from '../corte-caja/corte-caja.component';

import { direccionAddEditComponent } from '../cliente-sae/cliente-sae-agregar-editar/direcciones/direccionAddEdit.component';
import { FacturaDescargarComponent } from '../factura/consultar-eliminar/factura-descargar.component';
import { SucursalComponent } from '../compania/sucursales/sucursal.component';
import { ParametroSucursalComponent } from '../compania/sucursales/parametros/parametros-sucursal.component';
import { contactoAddEditComponent } from '../cliente-sae/cliente-sae-agregar-editar/contactos/contactoAddEddit.component';
import { CustomGridComponent } from '../utils/custom-grid/custom-grid.component';
import { GridColumnDataPipe } from '../utils/custom-grid/grid-column-data.pipe';

import { EntradaAlmacenComponent } from '../almacen/entradas/entrada-almacen.component';
import { agregarEntradaComponent } from '../almacen/entradas/agregar/agregarEntrada.component';
import { historialEntradaComponent } from '../almacen/entradas/historial/historialEntrada.component';
import { inventarioAlmacenComponent } from '../almacen/inventario/inventario-almacen.component';
import { SalidaAlmacenComponent } from '../almacen/salidas/salida-almacen.component';
import { agregarSalidaComponent } from '../almacen/salidas/agregar/agregarSalida.component';
import { historialSalidaComponent } from '../almacen/salidas/historial/historialSalida.component';

//Recibo Pago
import { ReciboPagoConsultarComponent } from '../recibo-pago/consultar-eliminar/recibo-pago-consultar.component';
import { ReciboPagoDetalleComponent } from '../recibo-pago/agregar-editar/recibo-pago-detalle.component';
import { ReciboPagoEliminarComponent } from '../recibo-pago/consultar-eliminar/recibo-pago-eliminar.component';
import { ReciboPagoDescargarComponent } from '../recibo-pago/consultar-eliminar/recibo-pago-descargar.component';
import { OrdenanteDetalleComponent } from '../recibo-pago/cuenta-ordenante/agregar-editar/cuenta-ordenante-detalle.component';
import { BeneficiarioDetalleComponent } from '../recibo-pago/cuenta-beneficiario/agregar-editar/cuenta-beneficiario-detalle.component';

//Nota Credito
import { NotaCreditoConsultarComponent } from '../nota-credito/consultar-eliminar/nota-credito-consultar.component';
import { NotaCreditoDetalleComponent } from '../nota-credito/agregar-editar/nota-credito-detalle.component';
import { NotaCreditoEliminarComponent } from '../nota-credito/consultar-eliminar/nota-credito-eliminar.component';
import { NotaCreditoDescargarComponent } from '../nota-credito/consultar-eliminar/nota-credito-descargar.component';

//Nota Cargo
import { NotaCargoConsultarComponent } from '../nota-cargo/consultar-eliminar/nota-cargo-consultar.component';
import { NotaCargoDetalleComponent } from '../nota-cargo/agregar-editar/nota-cargo-detalle.component';
import { NotaCargoEliminarComponent } from '../nota-cargo/consultar-eliminar/nota-cargo-eliminar.component';
import { NotaCargoDescargarComponent } from '../nota-cargo/consultar-eliminar/nota-cargo-descargar.component';

//Concentrado Pagos
import { ConcentradoPagosComponent } from '../pagos/concentrado-pagos.component';
// import {modalFechaPagoFactura} from '../factura/consultar-eliminar/fechaPago/fecha-pago.component';

import { ConsultaPagosComponent } from '../venta/consultar/consulta-de-pagos/consulta-de-pagos.component';

//Vehiculos
import {VehiculoConsultarComponent} from '../vehiculo/consultar-eliminar/vehiculos-consultar.component';
import {VehicleAddEditComponent} from '../vehiculo/vehiculo-agregar-editar/vehiculo-agregar-editar';

//choferes
import {ChoferConsultarComponent} from '../chofer/consultar-eliminar/choferes-consultar.component';
import {ChoferAddEditComponent} from '../chofer/agregar-editar/chofer-agregar.component';

// Dirrecion Compañia
import {CompanyAddressConsultarComponent} from '../direccionEmpresa/consultar-eliminar/direccionEmpresa-consultar.component';
import {CompanyAddressAddEditComponent} from '../direccionEmpresa/agregar-editar/direccionEmpresa-agregar.component';

import {ReporteAuxiliarCuentaComponent} from '../Contabilidad/reporteAuxiliarCuenta/reporteAuxiliarCuenta.component';
import {ReporteAuxiliarCuentaConsultarComponent} from '../Contabilidad/reporteAuxiliarCuenta/consultar/reporteAuxiliarCuenta-consultar.component';
import {PolizasComponent} from '../Contabilidad/polizas/polizas.component';
import {CuentaComponent} from '../Contabilidad/cuentas/cuentas.component';
import {CuentaConsultarComponent} from '../Contabilidad/cuentas/consultar/cuenta-consultar.component';
import {CuentaAddComponent} from '../Contabilidad/cuentas/cuentasAddEdit/cuentasAddEdit.component'
import {CuentaGenerarXMLComponent} from '../Contabilidad/cuentas/consultar/archivoXML/cuenta-generarXML.componen.'
import { PolizasConsultarComponent } from '../Contabilidad/polizas/polizas-consultar/polizas-consultar.component';
import { PolizasAgregarComponent } from '../Contabilidad/polizas/polizas-agregar/polizas-agregar.component';
import { PolizasAgregarViewComponent } from '../Contabilidad/polizas/polizas-agregar/polizas-agregar-view/polizas-agregar-view.component';
import { PolizasEditarComponent } from '../Contabilidad/polizas/polizas-editar/polizas-editar.component';
import { PolizasEditarViewComponent } from '../Contabilidad/polizas/polizas-editar/polizas-editar-view/polizas-editar-view.component';
import {BalanzaComprobacionXMLComponent} from '../Contabilidad/balanzaComprobacion/consultar/archivoXML/balanzaComprobacion-generarXML';
import {BalanzaComprobacionComponent} from '../Contabilidad/balanzaComprobacion/balanzaComprobacion.component';
import {BalanzaComprobacionConsultarComponent} from '../Contabilidad/balanzaComprobacion/consultar/balanzaComprobacion-consultar.component';

import {BalanceGeneralComponent} from '../Contabilidad/balanceGeneral/balanceGeneral.component';
import {BalanceGeneralConsultarComponent} from '../Contabilidad/balanceGeneral/consultar/balanceGeneral-consultar.component';
// import {AnalyticsComponent} from '../inicio/analytics/analytics.component';
// import {DiskSpaceComponent} from '../inicio/disk-space/disk-space.component';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import {EstadoResultadosComponent} from '../Contabilidad/estadoResultados/estadoResultados.component';
import {EstadoResultadosConsultarComponent} from '../Contabilidad/estadoResultados/consultar/estadoResultados-consultar.component';
import {Diot} from '../Contabilidad/diot/diot.component';
import {DiotConsultarComponent} from '../Contabilidad/diot/consultar/diot-consultar.component';
import {ConciliacioBancaria} from '../Contabilidad/conciliacionBancaria/conciliacioBancaria-component';
import {ConciliacionBancariaConsultarComponent} from '../Contabilidad/conciliacionBancaria/consultar/conciliacionBancaria-consultar.component';
import {CuentaBancariaConsultarComponent} from '../Contabilidad/cuentaBancaria/consultar-eliminar/cuentaBancaria-consultar.component';
import {CuentaBancariaAddEditComponent} from '../Contabilidad/cuentaBancaria/agregar-editar/cuentaBancaria-agregar.component';
import { ConciliacionBancariaDetComponent } from '../Contabilidad/conciliacionBancaria/conciliacion-bancaria-det/conciliacion-bancaria-det.component';
// import {UsuarioSAEConsultarComponent} from '../usuarioSAE/consultar-eliminar/usuarioSAE-consultar.component';
// import { UsuarioSAEAddEditComponent } from '../usuarioSAE/agregar-editar/usuarioSAE-AddEdit.component'
@NgModule({
  imports: [
    // Common Modules
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // END Common Modules
    LayoutRoutingModule,
    NgxDaterangepickerMd.forRoot(),
    NgSelectModule,
    MatFormFieldModule,
    NgxChartsModule
  ],
  declarations: [
    // Pages
    //Inicio
    InicioComponent,
    DiskSpaceComponent,
    AnalyticsComponent,
    // Personal
    PersonalComponent,
    PersonalConsultarComponent,
    PersonalDetalleComponent,
    PersonalEliminarComponent,
    ClienteComponent,
    ClienteConsultarComponent,
    ClienteDetalleComponent,
    HistorialPagosComponent,
    modalChangeToCashOutComponent,
    //Cuentas por cobrar
    cuentasCobrarComponent,
    //Cuentas por cobrar (Facturas)
    cuentasCobrarFacturaComponent,
    // Bitacora
    BitacoraComponent,
    BitacoraAddEditComponent,
    BitacoraClienteComponent,
    BitacoraClienteAddEditComponent,
    // familiar
    FamiliarComponent,
    FamiliarAddEditComponent,
    // cotizacion
    CotizacionComponent,
    CotizacionAddEditComponent,
    // asistencia
    controlAsistenciaNominaComponent,
    // usuario
    usuarioComponent,
    usuarioAddEditComponent,
    usuarioConsultarComponent,
    // nomina
    nominaComponent,
    generarNominaComponent,
    // ubicacion
    UbicacionAddEditComponent,
    UbicacionComponent,
    // personalCliente
    PersonalClienteComponent,
    UbicacionComponent,
    // personal documento
    documentoComponent,
    documentoAddEditComponent,
    // Compania
    CompaniaComponent,
    CompaniaConsultarComponent,
    CompaniaDetalleComponent,
    // Producto
    ProductComponent,
    ProductConsultDeleteComponent,
    ProductAddEditComponent,
    EditCodeSatComponent,
    EditUnitSatComponent,
    // Ventas - exportacion
    SaleExportComponent,
    CompaniaDetalleComponent,
    // venta
    VentaAgregarComponent,
    VentaConsultarComponent,
    // Descuentos
    DescuentosConsultarComponent,
    RetirosComponent,
    LastDirective,
    // Configuración de Compañía
    CompaniaConfiguracionComponent,
    // Lista de Precios
    ListaPreciosComponent,
    ListaPreciosAgregarEditarComponent,
    // Modal Confirmación
    modalConfirmationComponent,
    // Clientes SAE
    ClienteSaeComponent,
    ClienteSaeAgregarEditarComponent,
    direccionAddEditComponent,
    contactoAddEditComponent,
    // Corte Caja
    CorteCajaComponent,
    RealizarCorteCajaComponent,
    HistoricoCorteCajaComponent,
    // Pago de Ventas
    PagoVentaComponent,
    OnlyNumberDirective,
    modalComponent,
    // Facturas
    FacturaComponent,
    FacturaConsultarComponent,
    FacturaDetalleComponent,
    modalImpuestosRetendidos,
    FacturaEliminarComponent,
    FacturaDescargarComponent,
    CartaPorte,
    modalFechaPagoFactura,
    //Materiales
    MaterialesComponent,
    MaterialesConsultDeleteComponent,
    MaterialesAddEditComponent,
	  //Item Family
    ItemFamiliaComponent,
    ItemFamiliaConsultDeleteComponent,
    ItemFamiliaAddEditComponent,
    //Item Sat
    ItemSatConsultarComponent,
	  //Sucursales
    SucursalComponent,
    ParametroSucursalComponent,  
    //Item Family
    ItemSubFamiliaComponent,
    ItemSubFamiliaConsultDeleteComponent,
    ItemSubFamiliaAddEditComponent,
    ItemSatAddEditComponent,
    //Almacen
    EntradaAlmacenComponent,
    agregarEntradaComponent,
    historialEntradaComponent,
    inventarioAlmacenComponent,
    SalidaAlmacenComponent,
    agregarSalidaComponent,
    historialSalidaComponent,
    //Consulta de Pagos
    ConsultaPagosComponent,
    //ConcentragoPagos
    ConcentradoPagosComponent,

    CustomGridComponent,
    GridColumnDataPipe,
    ReciboPagoConsultarComponent,
    ReciboPagoEliminarComponent,
    ReciboPagoDescargarComponent,
    ReciboPagoDetalleComponent,
    NotaCreditoConsultarComponent,
    NotaCreditoDetalleComponent,
    NotaCreditoEliminarComponent,
    NotaCreditoDescargarComponent,
    OrdenanteDetalleComponent,
    BeneficiarioDetalleComponent,
    NotaCargoConsultarComponent,
    NotaCargoDetalleComponent,
    NotaCargoEliminarComponent,
    NotaCargoDescargarComponent,
    //Vehiculos
    VehiculoConsultarComponent,
    VehicleAddEditComponent,
    ChoferConsultarComponent,
    ChoferAddEditComponent,
    CompanyAddressConsultarComponent,
    CompanyAddressAddEditComponent,
    ReporteAuxiliarCuentaComponent,
    ReporteAuxiliarCuentaConsultarComponent,
    BalanzaComprobacionComponent,
    BalanzaComprobacionConsultarComponent,
    BalanceGeneralComponent,
    BalanceGeneralConsultarComponent,
    PolizasComponent,
    PolizasConsultarComponent,
    PolizasConsultarComponent,
    CuentaComponent,
    CuentaConsultarComponent,
    CuentaAddComponent,
    CuentaGenerarXMLComponent,
    PolizasAgregarComponent,
    PolizasAgregarViewComponent,
    PolizasEditarComponent,
    PolizasEditarViewComponent,
    BalanzaComprobacionXMLComponent,
    AnalyticsComponent,
    DiskSpaceComponent,
    EstadoResultadosComponent,
    EstadoResultadosConsultarComponent,
    Diot,
    DiotConsultarComponent,
    ConciliacioBancaria,
    ConciliacionBancariaConsultarComponent,
    CuentaBancariaConsultarComponent,
    CuentaBancariaAddEditComponent,
    ConciliacionBancariaDetComponent,
    // UsuarioSAEConsultarComponent,
    // UsuarioSAEAddEditComponent,
   ],
  exports: [
    LastDirective
  ],
  entryComponents: [
    usuarioAddEditComponent,
    generarNominaComponent,
    documentoAddEditComponent,
    modalConfirmationComponent,
    PersonalEliminarComponent,
    FamiliarAddEditComponent,
    CotizacionAddEditComponent,
    BitacoraAddEditComponent,
    BitacoraClienteAddEditComponent,
    UbicacionAddEditComponent,
    direccionAddEditComponent,
    modalComponent,
    FacturaEliminarComponent,
    ParametroSucursalComponent,
    FacturaDescargarComponent,
    CartaPorte,
    modalImpuestosRetendidos,
    modalFechaPagoFactura,
    contactoAddEditComponent,
    agregarEntradaComponent,
    historialEntradaComponent,
    historialSalidaComponent,
    modalChangeToCashOutComponent,
    agregarSalidaComponent,
    ReciboPagoEliminarComponent,
    ReciboPagoDescargarComponent,
    ReciboPagoDetalleComponent,
    NotaCreditoDetalleComponent,
    NotaCreditoEliminarComponent,
    NotaCreditoDescargarComponent,
    NotaCargoDetalleComponent,
    NotaCargoEliminarComponent,
    NotaCargoDescargarComponent,
    OrdenanteDetalleComponent,
    BeneficiarioDetalleComponent,
    ConsultaPagosComponent,
    ConcentradoPagosComponent,
    modalFechaPagoFactura,
    VehiculoConsultarComponent,
    VehicleAddEditComponent,
    ChoferConsultarComponent,
    ChoferAddEditComponent,
    CompanyAddressConsultarComponent,
    CompanyAddressAddEditComponent,
    CuentaGenerarXMLComponent,
    BalanzaComprobacionXMLComponent,
    ItemSatAddEditComponent,
    CuentaBancariaConsultarComponent,
    CuentaBancariaAddEditComponent,
    // UsuarioSAEConsultarComponent,
    // UsuarioSAEAddEditComponent,
  ],
  providers: [ DataService, PagoVentaService, 
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MatPaginatorIntl, useValue: getESPaginatorIntl() },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ],
})

export class LayoutModule {}



// WEBPACK FOOTER //
// ./src/app/layout/layout.module.ts